import store from "@/store";
import router from "@/router";
import { EventBus } from "@/utils/eventBus";
import Vue from "vue";
class Tools {
  /**
   * 获取当前时间戳，秒级
   * @constructor
   */
  getDateTime() {
    return Math.floor(new Date().getTime() / 1000);
  }

  /**
   * 获取token
   * @returns {string}
   */
  getToken() {
    return localStorage.getItem("token");
  }

  /**
   * 设置token
   * @param token
   */
  setToken(token) {
    EventBus.$emit("wsSendMsg", {
      type: "login",
      platform: 7,
      token: token,
    });
    store.dispatch("user/initPermission");
    store.dispatch("paper/getSanLiQuestions");
    localStorage.setItem("token", token);
    store.dispatch("user/initPermission");
    store.dispatch("paper/initSetting");
  }

  /**
   * 删除token
   */
  delToken() {
    localStorage.removeItem("token");
  }

  /**
   * 科目符号切割
   * @returns {boolean}
   */
  splitSubject(str) {
    let str_tem = str.split(":")[1];
    if (str_tem === "EXAM_SUBJECT_2" || str_tem === "EXAM_SUBJECT_3") {
      return true;
    } else {
      return false;
    }
  }

  /**
   * 车型科目回显
   */
  cartypesubjectecho(carlist = []) {
    // 车型合并
    const mergecar = [...carlist.driver, ...carlist.qualification];
    // 用户信息
    const userinfo = store.getters["user/userInfo"];
    if (!userinfo) {
      return {};
    }
    // 当前的车型
    const current_car_type =
      mergecar.find((item) => item.id === userinfo.car_type_id) || {};
    current_car_type.car_subject = current_car_type.car_subject || [];
    // 当前选择科目的下标
    let current_tab_list_index = current_car_type.car_subject.find(
      (item) => item.id === userinfo.car_subject_id
    );

    console.log(process.env.VUE_APP_ENV);
    const is_nx = process.env.VUE_APP_ENV === "nx";

    // 当前的tab
    let current_tab_list = current_car_type.car_subject;
    if (is_nx) {
      current_tab_list = current_tab_list.filter((item) => {
        return !["科目二", "科目三"].includes(item.name);
      });
    }

    return {
      current_car_type,
      current_tab_list_index,
      current_tab_list,
    };
  }

  /**
   * 科目判断
   */
  splitStr(str, suffix) {
    const signs = str.split(":")[1];
    return signs === `EXAM_SUBJECT_${suffix}`;
  }

  /**
   * 是否资格证判断
   */
  is_qualification() {
    try {
      const driver_arr = store.getters["user/carlist"]?.driver || [];
      const car_type_id = store.getters["user/userInfo"].car_type_id;
      const exists = driver_arr.some((item) => item.id === car_type_id);
      return !exists;
    } catch (e) {
      return null;
    }
  }
  get_subject_name() {
    const driver_arr = store.getters["user/carlist"]?.driver || [];
    const car_type_id = store.getters["user/userInfo"].car_type_id;
    const car_subject_id = store.getters["user/userInfo"].car_subject_id;
    return driver_arr
      .find((item) => item.id === car_type_id)
      ?.car_subject.find((item) => item.id === car_subject_id)?.name;
  }
  /**
   * 退出登录清空信息
   */
  logout() {
    this.delToken();
    store.dispatch("user/logout");

    if (window.location.hash == "#/") {
      window.nw ? nw.Window.get().reload() : window.location.reload();
    } else {
      router.replace(
        {
          path: "/",
        },
        () => {
          window.nw ? nw.Window.get().reload() : window.location.reload();
        }
      );
    }
  }

  getOrigin() {
    return window.location.protocol + "//" + window.location.host;
  }
  isFutureTime(timeStr) {
    // 替换成 T 符合 ISO 标准，保证跨平台解析没问题
    const formatted = timeStr.replace(" ", "T");
    const inputDate = new Date(formatted);
    const now = new Date();

    if (isNaN(inputDate.getTime())) {
      throw new Error("传入的时间格式不正确，必须是 YYYY-MM-DD HH:mm:ss");
    }

    return inputDate > now;
  }
  hasPre() {
    const list = store.getters["user/permissionList"] || [];
    const userInfo = store.getters["user/userInfo"] || { car_subject_id: null };
    const item = list.find((i) => i.car_subject_id === userInfo.car_subject_id);
    if (!item) return true;
    if (item.pay_state == 0) return true;
    if (!item.end_time) return false;
    return this.isFutureTime(item.end_time);
  }
  parseUrlParams(url) {
    if (!url) return {};

    // 拆分出 query 和 hash 部分
    const [beforeHash, afterHash] = url.split("#");
    const searchPart = beforeHash.split("?")[1] || ""; // 处理 ? 在前面
    let hashQuery = "";

    // 处理 hash 部分（可能包含路径 + 参数）
    if (afterHash) {
      const [, query] = afterHash.split("?");
      hashQuery = query || "";
    }

    // 合并两部分参数
    const queryString = [searchPart, hashQuery].filter(Boolean).join("&");
    const params = {};

    queryString.split("&").forEach((pair) => {
      if (!pair) return;
      const [key, value] = pair.split("=");
      params[decodeURIComponent(key)] =
        value !== undefined ? decodeURIComponent(value) : true;
    });

    return params;
  }
  hasVip() {
    const params = this.parseUrlParams(window.location.href);
    if (params.free_experience) return true;
    const vipInfo = store.getters["user/getVipInfo"];
    return vipInfo && !vipInfo.expired;
  }
  isNewUser() {
    const userInfo = store.getters["user/userInfo"];
    if (!userInfo) return null;
    if (!userInfo.city_id) {
      return "请先选择所在城市";
    }
    if (!userInfo.car_type_id) {
      return "请先选择车型";
    }
    return null;
  }
}

export default new Tools();
